import type { ViewConfig } from "@kontextwerk/control-web-frame"

export const workspaceConfig = {
  viewId: "organization",
  subview: { id: "property", parentPageId: "administration", parentTabTitle: "Liegenschaften" },
} satisfies NonNullable<ViewConfig["workspace"]>
